
import { Subject } from 'rxjs';

const subject = new Subject();

export const treeUpdateService = {
    sendTree: tree => subject.next(tree),
    clearTree: () => subject.next(),
    getTree: () => subject.asObservable()
};